module.exports = __webpack_public_path__ + "static/img/jp1-3.853dd3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/jp1-3.png
// module id = 914
// module chunks = 0